import { render } from "./ConfigOrganisationDailyReportMail.vue?vue&type=template&id=296fbba4"
import script from "./ConfigOrganisationDailyReportMail.vue?vue&type=script&lang=js"
export * from "./ConfigOrganisationDailyReportMail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__